module.exports = "<section layout=row layout-fill layout-align=\"center top\"> <md-card layout-padding class=centered-card> <h3 translate>ABOUT_US</h3> <cms content-name=\"'about'\"></cms> </md-card> </section>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/hydromet/about/about.html
 ** module id = 272
 ** module chunks = 0
 **/